import { BaseDataService } from './basedata.service';
import { HttpService } from './http.service';
import { API_URL } from '../../constants/url.constants';
import { BaseDataModel, ResponseAndErrorModel } from 'common/models/utilitymodels/base.model';
import { HeadersList, ListModel, ListParams, MinMaxFilter, QueryParams, paginationType } from '../../models/utilitymodels/list.model';

export abstract class ListDataService<T extends BaseDataModel, G extends ListModel<BaseDataModel>> extends BaseDataService<T> {
    constructor(public API_URL: API_URL, protected httpService: HttpService) {
        super(API_URL, httpService);
    }

    getAPI_URL(): API_URL {
        return this.API_URL;
    }

    modifyAPI_URL(params: any): string {
        return this.getAPI_URL();
    }

    abstract createQueryParams(param: any): ListParams;

    getData(param: QueryParams): Promise<T> {
        return new Promise<T>((resolve, reject) => {
            Promise.resolve()
                .then(() => {
                    return this.createQueryParams(param);
                })
                .then((queryparams: any) => {
                    return this.listgetDatafromAPI(queryparams);
                })
                .then((result) => {
                    return this.beforeGetListData(result);
                })
                .then((result) => {
                    return this.createListModel(result, param);
                })
                .then((result) => {
                    return this.afterGetListData(result);
                })
                .then((finalresult) => {
                    resolve(finalresult);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    transformSuccessData(data: any, params: any) {
        let apiRes = [];
        if (data.Error) {
            apiRes = [];
        } else {
            apiRes = data;
        }
        const res = new ResponseAndErrorModel(apiRes, []);
        return res;
    }

    transformErrorData(error: any, params: any) {
        const res = new ResponseAndErrorModel([], [{ ...error }]);
        return res;
    }

    beforeGetListData(model: T): Promise<T> {
        return new Promise<T>((resolve, reject) => {
            resolve(model);
        });
    }

    afterGetListData(model: T): Promise<T> {
        return new Promise<T>((resolve, reject) => {
            resolve(this.transformAPIData(model));
        });
    }

    transformAPIData(data: T) {
        return data;
    }

    transformListData(res: any) {
        return res;
    }

    protected cloneData(data: any): any {
        return JSON.parse(JSON.stringify(data));
    }

    createListModel(apiRes: any, param: QueryParams): Promise<any> {
        return new Promise((resolve, reject) => {
            try {
                const listModel = new ListModel<T>();
                const data = apiRes.data;
                listModel.errorModel = apiRes.error;
                listModel.list = this.transformListData(data);
                listModel.listMaster = listModel.list;
                listModel.pageModel = [];
                listModel.pages = [];
                listModel.searchText = '';
                listModel.selectedPage = param.currentPage;
                listModel.searchText = param.searchText;
                listModel.recordPerPage = param.recordPerPage;
                listModel.totalRecords = listModel.list?.length;
                listModel.filterList = this.filterDataByValue(listModel.list, '', '');
                listModel.filterList = this.filterData(listModel.filterList, [...param.filterFeilds], param.searchText);
                listModel.filterList = this.sortListData(listModel.filterList, param.sortingFeild);
                listModel.filterList = this.minMaxFilter(listModel.filterList, param.minMaxFilter);
                const pageData = this.getPageData(this.cloneData(listModel.filterList), param.recordPerPage, param.currentPage, param.paginationType);
                listModel.pageModel = pageData.pageModel;
                listModel.pages = pageData.pages;
                resolve(listModel);
            } catch (e) {
                reject(e);
            }
        });
    }

    filterDataByValue(originalModel: T[], headersFeidName: string, value: string) {
        return originalModel;
    }

    minMaxFilter(originalModel: any, minMaxFilter: MinMaxFilter[]): T[] {
        if (minMaxFilter.length === 0) {
            return originalModel;
        }
        const filterFeilds = minMaxFilter;
        let filterDataModel = originalModel.filter((data: any) => this.filterMinMaxHelper(data, filterFeilds));
        return filterDataModel;
    }

    filterMinMaxHelper(data: any, filterFeilds: MinMaxFilter[]) {
        let isValid = true;
        for (let filter of filterFeilds) {
            if ((filter.rangeValue.min === 0 && filter.rangeValue.max === 0) || (filter.rangeValue.min === null && filter.rangeValue.max === null)) {
                continue;
            }
            if (data[filter.fieldName] >= filter.rangeValue.min && data[filter.fieldName] <= filter.rangeValue.max) {
                isValid = isValid && true;
            } else {
                isValid = isValid && false;
            }
        }
        return isValid;
    }

    getPageData(originalModel: any, recordPerPage: any, pageNumber: any, type: paginationType): ListModel<T> {
        const pageData = new ListModel<T>();
        const data = type === 'load more' ? originalModel.slice(0, recordPerPage * pageNumber) : originalModel.slice((pageNumber - 1) * recordPerPage, recordPerPage * pageNumber);
        pageData.pageModel = data;
        const numberOfPage = Math.ceil(originalModel.length / recordPerPage);
        pageData.pages = Array.from({ length: numberOfPage }, (_, idx) => ++idx);
        return pageData;
    }

    filterData(originalModel: T[], headers: any, filter: string): T[] {
        if (headers.length === 0) {
            return originalModel;
        }
        const filterFeilds = headers; // this.getFilterFeilds(headers);
        let filterDataModel = originalModel.filter((data) => this.filterHelper(data, filterFeilds, filter.trim()));
        filterDataModel = this.modifyfilteredModel(filterDataModel);
        return filterDataModel;
    }

    modifyfilteredModel(filterDataModel: T[]): any {
        return filterDataModel;
    }

    filterHelper(data: any, headers: any, filter: string): boolean {
        for (const header of headers) {
            if (data[header]?.toLowerCase().includes(filter.toLowerCase())) {
                return true;
            }
        }
        return false;
    }

    sortListData(originalModel: any, sortFieldHeader: HeadersList): T[] {
        let sortedData: T[] = [];
        if (!sortFieldHeader || sortFieldHeader.sortingOrder === '0') {
            sortedData = originalModel;
        } else {
            if (sortFieldHeader.feildType === 'text') {
                sortedData = originalModel.sort((a: any, b: any) => {
                    if (sortFieldHeader.sortingOrder === '-1') {
                        const c: HeadersList = b;
                        b = a;
                        a = c;
                    }
                    return a[sortFieldHeader.keyName].localeCompare(b[sortFieldHeader.keyName]);
                });
            } else if (sortFieldHeader.feildType === 'number') {
                sortedData = originalModel.sort((a: any, b: any) => {
                    if (sortFieldHeader.sortingOrder === '-1') {
                        const c: HeadersList = b;
                        b = a;
                        a = c;
                    }
                    return a[sortFieldHeader.keyName] - b[sortFieldHeader.keyName];
                });
            }
        }
        return sortedData;
    }
}
